const productLists = document.querySelectorAll('[data-component="mod-product-list"]');

productLists.forEach((productList) => {
  const listContainer = productList.querySelector('[data-product-list-items]');
  const loadMoreWrap = productList.querySelector('[data-product-list-load-more]');

  if (!listContainer) {
    return;
  }

  const postId = productList.dataset.postId || '';
  const moduleIndex = productList.dataset.moduleIndex || '';
  const categories = productList.dataset.categories || '';
  const perPage = parseInt(productList.dataset.perPage || '12', 10);
  let isDefaultSort = !new URL(window.location.href).searchParams.has('sort');
  let suppressPriceChange = false;
  let priceFilterActive = null;
  let requestVersion = 0;
  let requestController = null;

  const pushViewItemList = (analyticsList) => {
    if (analyticsList?.items?.length) {
      pushEcommerceEvent('view_item_list', analyticsList);
    }
  };

  try {
    pushViewItemList(JSON.parse(productList.dataset.analyticsList || 'null'));
  } catch (err) {
    console.error(err);
  }

  const setLoading = (isLoading) => {
    if (loadMoreWrap) {
      loadMoreWrap.classList.toggle('is-loading', isLoading);
    }
  };

  const getActiveSort = () => {
    const active = productList.querySelector('.sort-dropdown input[name="product-sort"]:checked');
    return active && !isDefaultSort ? active.value : '';
  };

  const parsePriceValue = (value) => {
    const num = parseInt(String(value ?? '').replace(/[^\d]/g, ''), 10);
    return Number.isNaN(num) ? '' : num;
  };

  const getSizeValues = (input) => (input.dataset.sizeValues || input.value).split(',').filter(Boolean);

  const getFilters = () => {
    const sizes = new Set();
    productList.querySelectorAll('.product-filter__list input[name="size"]:checked').forEach((input) => {
      getSizeValues(input).forEach((value) => sizes.add(value));
    });

    const categoryGroups = {};
    const categoryOptions = {};
    productList.querySelectorAll('.product-filter__list input[name^="product_cat__"]').forEach((input) => {
      const groupName = input.name.replace('product_cat__', '');
      if (!categoryGroups[groupName]) {
        categoryGroups[groupName] = [];
      }
      if (!categoryOptions[groupName]) {
        categoryOptions[groupName] = [];
      }
      if (!categoryOptions[groupName].includes(input.value)) {
        categoryOptions[groupName].push(input.value);
      }
      if (input.checked) {
        categoryGroups[groupName].push(input.value);
      }
    });

    const priceMinInput = productList.querySelector('input[name="price-min"]');
    const priceMaxInput = productList.querySelector('input[name="price-max"]');
    const sliderEl = productList.querySelector('[data-component="mol-range-slider"] .range-slider__input');
    const sliderMin = parsePriceValue(sliderEl?.dataset.min);
    const sliderMax = parsePriceValue(sliderEl?.dataset.max);
    const priceMin = parsePriceValue(priceMinInput?.value);
    const priceMax = parsePriceValue(priceMaxInput?.value);
    if (priceFilterActive === null) {
      const url = new URL(window.location.href);
      priceFilterActive = url.searchParams.has('price_min') || url.searchParams.has('price_max');
    }

    return {
      sizes: [...sizes],
      categoryGroups,
      categoryOptions,
      sliderMin,
      sliderMax,
      priceMin: priceFilterActive && priceMin !== '' ? priceMin : '',
      priceMax: priceFilterActive && priceMax !== '' ? priceMax : '',
      priceActive: priceFilterActive,
    };
  };

  const applyAvailability = (availability) => {
    if (availability?.sizes) {
      const availableSizes = new Set(availability.sizes);
      productList.querySelectorAll('.product-filter__list input[name="size"]').forEach((input) => {
        const isHidden = !input.checked && !getSizeValues(input).some((value) => availableSizes.has(value));
        input.closest('.size-selector__item')?.classList.toggle('hide', isHidden);
      });
    }

    const availableCategories = availability?.categories || {};
    productList.querySelectorAll('.product-filter__list input[name^="product_cat__"]').forEach((input) => {
      const groupName = input.name.replace('product_cat__', '');
      if (!Object.prototype.hasOwnProperty.call(availableCategories, groupName)) {
        return;
      }
      const isHidden = !input.checked && !availableCategories[groupName].includes(input.value);
      input.closest('.checkbox-group__list-item')?.classList.toggle('hide', isHidden);
      const count = availability.category_counts?.[groupName]?.[input.value];
      const countEl = input.closest('.checkbox')?.querySelector('.checkbox__label .text--gray-500');
      if (countEl && Number.isInteger(count)) {
        countEl.textContent = `(${count})`;
      }
    });
  };

  const updatePriceRange = (priceRange) => {
    const sliderEl = productList.querySelector('[data-component="mol-range-slider"] .range-slider__input');
    const startInput = productList.querySelector('input[name="price-min"]');
    const endInput = productList.querySelector('input[name="price-max"]');

    if (!sliderEl || !startInput || !endInput) {
      return;
    }

    const min = parsePriceValue(priceRange?.min);
    const max = parsePriceValue(priceRange?.max);
    if (min === '' || max === '' || min >= max) {
      return;
    }

    const handleMin = parsePriceValue(priceRange?.handle_min);
    const handleMax = parsePriceValue(priceRange?.handle_max);
    const nextMin = min;
    const nextMax = max;
    const fallbackStart =
      priceFilterActive && handleMin !== '' ? Math.min(Math.max(handleMin, nextMin), nextMax) : nextMin;
    const fallbackEnd =
      priceFilterActive && handleMax !== '' ? Math.min(Math.max(handleMax, nextMin), nextMax) : nextMax;
    const currentStart = parsePriceValue(startInput.value);
    const currentEnd = parsePriceValue(endInput.value);
    let nextStart = fallbackStart;
    let nextEnd = fallbackEnd;

    if (priceFilterActive && currentStart !== '' && currentEnd !== '') {
      nextStart = Math.min(Math.max(currentStart, nextMin), nextMax);
      nextEnd = Math.min(Math.max(currentEnd, nextMin), nextMax);
      if (nextStart > nextEnd) {
        nextStart = fallbackStart;
        nextEnd = fallbackEnd;
      }
    }

    sliderEl.setAttribute('data-min', String(nextMin));
    sliderEl.setAttribute('data-max', String(nextMax));
    sliderEl.setAttribute('data-from', String(nextStart));
    sliderEl.setAttribute('data-to', String(nextEnd));

    if (sliderEl.noUiSlider) {
      suppressPriceChange = true;
      try {
        sliderEl.noUiSlider.updateOptions({
          range: {
            min: nextMin,
            max: nextMax,
          },
        });
        sliderEl.noUiSlider.set([nextStart, nextEnd]);
      } finally {
        suppressPriceChange = false;
      }
    } else {
      startInput.value = String(nextStart);
      endInput.value = String(nextEnd);
    }
  };

  const resetPriceSlider = () => {
    const slider = productList.querySelector('[data-component="mol-range-slider"] .range-slider__input')?.noUiSlider;
    if (!slider) {
      return;
    }

    const { min, max } = slider.options.range;
    slider.set([min, max]);
  };

  const updateUrl = (state) => {
    const url = new URL(window.location.href);

    url.searchParams.delete('sort');
    url.searchParams.delete('sizes');
    url.searchParams.delete('category');
    url.searchParams.delete('price_min');
    url.searchParams.delete('price_max');
    url.searchParams.delete('page-number');

    if (state.sort && state.sort !== 'date-desc') {
      url.searchParams.set('sort', state.sort);
    }
    if (state.sizes && state.sizes.length > 0) {
      url.searchParams.set('sizes', state.sizes.join(','));
    }
    if (state.priceActive && state.priceMin !== '') {
      url.searchParams.set('price_min', String(state.priceMin));
    }
    if (state.priceActive && state.priceMax !== '') {
      url.searchParams.set('price_max', String(state.priceMax));
    }
    if (state.page > 1) {
      url.searchParams.set('page-number', String(state.page));
    }

    let urlStr = url.toString();
    if (state.categoryGroups && Object.keys(state.categoryGroups).length > 0) {
      const catParams = Object.entries(state.categoryGroups)
        .filter(([, slugs]) => slugs.length > 0)
        .map(([group, slugs]) => `category=${group}:${slugs.join(',')}`)
        .join('&');
      if (catParams) {
        urlStr += (urlStr.includes('?') ? '&' : '?') + catParams;
      }
    }

    window.history.replaceState({}, '', urlStr);
  };

  const fetchProducts = async (page, sort, mode = 'replace', origin = 'other') => {
    // Only the newest selection may update products, counts and the URL.
    requestVersion += 1;
    const currentRequestVersion = requestVersion;
    requestController?.abort();
    requestController = new AbortController();
    try {
      setLoading(true);

      if (origin === 'price') {
        priceFilterActive = true;
      }

      const filters = getFilters();

      updateUrl({
        page,
        sort,
        sizes: filters.sizes,
        categoryGroups: filters.categoryGroups,
        priceMin: filters.priceMin,
        priceMax: filters.priceMax,
        priceActive: filters.priceActive,
        sliderMin: filters.sliderMin,
        sliderMax: filters.sliderMax,
      });

      const payload = {
        action: 'getProductListData',
        postId,
        moduleIndex,
        categories,
        perPage,
        page,
        sort,
        sizes: filters.sizes,
        priceMin: filters.priceMin,
        priceMax: filters.priceMax,
        categoryOptions: filters.categoryOptions,
      };

      Object.entries(filters.categoryGroups).forEach(([group, slugs]) => {
        payload[`category_${group}`] = slugs;
      });

      const { data } = await axios.post(localData.siteURL, payload, { signal: requestController.signal });

      if (currentRequestVersion !== requestVersion || !data?.success) {
        return;
      }

      const html = (data.data.html_list || '').trim();
      applyAvailability(data.data.availability);
      if (origin === 'filter') {
        updatePriceRange(data.data.price_range);
      }
      const updatedFilters = getFilters();
      updateUrl({
        page,
        sort,
        sizes: updatedFilters.sizes,
        categoryGroups: updatedFilters.categoryGroups,
        priceMin: updatedFilters.priceMin,
        priceMax: updatedFilters.priceMax,
        priceActive: updatedFilters.priceActive,
        sliderMin: updatedFilters.sliderMin,
        sliderMax: updatedFilters.sliderMax,
      });

      if (mode === 'replace') {
        listContainer.innerHTML = html;
      } else {
        listContainer.insertAdjacentHTML('beforeend', html);
      }

      if (loadMoreWrap) {
        loadMoreWrap.style.display = data.data.has_more ? '' : 'none';
      }

      const totalResultsEl = productList.querySelector('.product-list__results-text');
      if (totalResultsEl && data.data.total_results) {
        totalResultsEl.textContent = data.data.total_results;
      }

      productList.dataset.currentPage = String(page);
      pushViewItemList(data.data.analytics_list);
    } catch (err) {
      if (!axios.isCancel(err)) {
        console.error(err);
      }
    } finally {
      if (currentRequestVersion === requestVersion) {
        setLoading(false);
      }
    }
  };

  // Sort change
  attachEvent('.sort-dropdown input[name="product-sort"]', 'change', (ev) => {
    if (!ev.target.closest('[data-component="mod-product-list"]')?.isSameNode(productList)) {
      return;
    }
    isDefaultSort = false;
    fetchProducts(1, ev.target.value, 'replace', 'other');
  });

  // Filter inputs change
  attachEvent('.product-filter__list input', 'change', (ev) => {
    if (!ev.target.closest('[data-component="mod-product-list"]')?.isSameNode(productList)) {
      return;
    }
    fetchProducts(1, getActiveSort(), 'replace', 'filter');
  });

  // Range slider change (custom event from range-slider.js)
  attachEvent('[data-component="mol-range-slider"] .range-slider__input', 'rangeSlider:change', (ev) => {
    if (suppressPriceChange) {
      return;
    }
    if (!ev.target.closest('[data-component="mod-product-list"]')?.isSameNode(productList)) {
      return;
    }
    fetchProducts(1, getActiveSort(), 'replace', 'price');
  });

  // Price inputs change (manual edits / fallback)
  productList.querySelectorAll('input[name="price-min"], input[name="price-max"]').forEach((input) => {
    input.addEventListener('change', () => {
      fetchProducts(1, getActiveSort(), 'replace', 'price');
    });
  });

  // Remove selected filter pill
  attachEvent('.product-filter__selected', 'click', (ev) => {
    const selected = ev.target.closest('.product-filter__selected');
    if (!selected) {
      return;
    }
    const eventPath = ev.composedPath ? ev.composedPath() : [];
    if (
      !eventPath.includes(productList) &&
      !selected.closest('[data-component="mod-product-list"]')?.isSameNode(productList)
    ) {
      return;
    }
    const inputId = selected.getAttribute('data-filter-id');

    if (inputId === 'price-range') {
      requestAnimationFrame(() => {
        priceFilterActive = false;
        resetPriceSlider();
        fetchProducts(1, getActiveSort(), 'replace', 'filter');
      });
      return;
    }

    const input = [...productList.querySelectorAll('.product-filter__list input')].find(
      (filterInput) => filterInput.id === inputId,
    );
    if (!input) {
      return;
    }
    requestAnimationFrame(() => {
      input.checked = false;
      fetchProducts(1, getActiveSort(), 'replace', 'filter');
    });
  });

  // Reset filters
  attachEvent('[data-reset-filter]', 'click', () => {
    requestAnimationFrame(() => {
      productList.querySelectorAll('.product-filter__list input').forEach((input) => {
        input.checked = false;
      });
      productList.querySelectorAll('.product-filter__selected').forEach((btn) => {
        btn.remove();
      });
      priceFilterActive = false;
      resetPriceSlider();
      fetchProducts(1, getActiveSort(), 'replace', 'filter');
    });
  });

  // Load more
  if (loadMoreWrap) {
    loadMoreWrap.addEventListener('click', (ev) => {
      const button = ev.target.closest('.load-more-products');
      if (!button) {
        return;
      }
      ev.preventDefault();

      const currentPage = parseInt(productList.dataset.currentPage || '1', 10);
      fetchProducts(currentPage + 1, getActiveSort(), 'append', 'other');
    });
  }
});
